import { CreateFocusCss } from '../../../../styles'
import type { Tokens } from '../../../../theming/types'
import type { BaseButtonProps } from '../BaseButton'

export default (config: {
  props: Pick<BaseButtonProps, 'kind'>
  tokens: Tokens
}) => {
  const { tokens } = config
  const { kind } = config.props

  const kindStyles = {
    brand: {
      active: {
        backgroundColor: tokens.ctaBgColorBrandActive,
      },
      color: {
        backgroundColor: tokens.ctaBgColorBrandDefault,
        borderColor: 'transparent',
        color: tokens.fontColorInverse,
      },
      disabled: {
        backgroundColor: tokens.ctaBgColorBrandDefault,
      },
      hover: {
        backgroundColor: tokens.ctaBgColorBrandHover,
      },
    },
    primary: {
      active: {
        backgroundColor: tokens.ctaBgColorPrimaryActive,
      },
      color: {
        backgroundColor: tokens.ctaBgColorPrimaryDefault,
        borderColor: 'transparent',
        color: tokens.fontColorInverse,
      },
      disabled: {
        backgroundColor: tokens.ctaBgColorPrimaryDefault,
      },
      hover: {
        backgroundColor: tokens.ctaBgColorPrimaryHover,
        color: tokens.fontColorInverse,
      },
    },
    secondary: {
      active: {
        backgroundColor: tokens.ctaBgColorSecondaryActive,
        borderColor: tokens.ctaBorderColorSecondaryActive,
      },
      color: {
        backgroundColor: tokens.ctaBgColorSecondaryDefault,
        borderColor: tokens.ctaBorderColorSecondaryDefault,
        color: tokens.fontColorDefault,
      },
      disabled: {
        backgroundColor: tokens.ctaBgColorSecondaryDefault,
      },
      hover: {
        backgroundColor: tokens.ctaBgColorSecondaryHover,
        borderColor: tokens.ctaBorderColorSecondaryHover,
        color: tokens.fontColorDefault,
      },
    },
    tertiary: {
      active: {
        backgroundColor: tokens.ctaBgColorTertiaryActive,
      },
      color: {
        backgroundColor: tokens.ctaBgColorTertiaryDefault,
        borderColor: 'transparent',
        color: tokens.fontColorDefault,
      },
      disabled: {
        backgroundColor: tokens.ctaBgColorTertiaryDefault,
      },
      hover: {
        backgroundColor: tokens.ctaBgColorTertiaryHover,
        color: tokens.fontColorDefault,
      },
    },
    danger: {
      active: {
        backgroundColor: tokens.ctaBgColorDangerActive,
      },
      color: {
        backgroundColor: tokens.ctaBgColorDangerDefault,
        borderColor: 'transparent',
        color: tokens.fontColorInverse,
      },
      disabled: {
        backgroundColor: tokens.ctaBgColorDangerDefault,
      },
      hover: {
        backgroundColor: tokens.ctaBgColorDangerHover,
        color: tokens.fontColorInverse,
      },
    },
  }

  return {
    button: {
      default: {
        ...kindStyles[kind!].color,
        alignItems: 'center',
        borderRadius: tokens.radiusSizeXS,
        borderStyle: 'solid',
        borderWidth: '1px',
        cursor: 'pointer',
        display: 'inline-flex',
        justifyContent: 'center',
        transitionDuration: '0.1s',
        transitionProperty: 'background-color, border-color, color',
        transitionTimingFunction: 'cubic-bezier(0.33, 0, 0.67, 1)',
        verticalAlign: 'middle',

        ...CreateFocusCss(tokens.focusOuter),

        '&:hover': { ...kindStyles[kind!].hover },
        '&:active, &[aria-expanded="true"]': { ...kindStyles[kind!].active },
        '&:disabled': {
          opacity: tokens.opacityDisabled,
          cursor: 'not-allowed',
          ...kindStyles[kind!].disabled,
        },
      },

      activated: {
        ...kindStyles[kind!].active,
      },
    },
  } as const
}
